import React from 'react';
import {
  SlideDescription,
  PointText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const DecisionPointSlide = ({
  slide,
  highlightWord,
  slideEdits = {},
  showEnglishContent = false,
}) => {
  const dp = slide?.DecisionData;
  const accent = '#3D5AFE';

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  if (!dp) {
    return (
      <SlideDescription>
        <SlideTitleHeader
          slide={slide}
          slideEdits={slideEdits}
          showEnglishContent={showEnglishContent}
          highlightWord={highlightWord}
        />
        {renderTextWithId('content_0', slide?.SlideContent, PointText, {}, textRendererOptions)}
      </SlideDescription>
    );
  }

  return (
    <SlideDescription>
      <SlideTitleHeader
        slide={slide}
        slideEdits={slideEdits}
        showEnglishContent={showEnglishContent}
        highlightWord={highlightWord}
      />
      {dp.decision_question && (
        <div style={{ borderLeft: `4px solid ${accent}`, background: `${accent}10`, padding: '12px 16px', borderRadius: 8, margin: '8px 0 12px', fontWeight: 600 }}>
          {renderTextWithId('dp_q', dp.decision_question, 'span', {}, textRendererOptions)}
        </div>
      )}
      {dp.context_hint && (
        <PointText style={{ fontStyle: 'italic', marginBottom: 8 }}>
          {renderTextWithId('dp_hint', dp.context_hint, 'span', {}, textRendererOptions)}
        </PointText>
      )}
      <ul>
        {(dp.options || []).map((o, idx) => (
          <li key={idx}>
            <PointText>{renderTextWithId(`dp_opt_${idx}`, o, 'span', {}, textRendererOptions)}</PointText>
          </li>
        ))}
      </ul>
    </SlideDescription>
  );
};

export default DecisionPointSlide;
